import client, { ApiResponse } from '../config/axiosConfig';

export const GetFooterInfo = async (): Promise<ApiResponse> => client.get('/info/footer');
